<template>
  <div class="product-hurry-box-container">
    <div class="hurry-box-header">
      <div v-if="title" class="hurry-box-title">{{ title || 'Hurry Box' }}</div>
      <div class="hurry-box-actions-wrapper">
        <div
          class="hurry-box-actions"
          :class="{ 'hurry-box-actions-disabled': !sections.length }"
          @click="sections.length && handleCopySections()"
        >
          <v-icon color="primary" size="16">mdi-content-copy</v-icon>
          <span>Copy Sections</span>
        </div>
        <div class="hurry-box-actions" @click="handlePasteSections">
          <v-icon color="primary" size="16">mdi-content-paste</v-icon>
          <span>Paste Sections</span>
        </div>
        <div
          v-if="behaviorCreateDescription.showSwitchCreateDescription"
          class="hurry-box-actions"
          @click="handleSwitchCreateDescription"
        >
          <v-icon color="primary" size="20">mdi-swap-horizontal</v-icon>
          <span>{{ behaviorCreateDescription.nameActionSwitch }}</span>
        </div>
      </div>
    </div>
    <div class="mb-5" v-if="behaviorCreateDescription.showCkEditor">
      <ckeditor :editor="editor" v-model="catalog[model]" :config="editorConfig" />
    </div>
    <!-- placeholder-add-new -->
    <div
      class="placeholder-add-new"
      @click="handleInsertNewSection()"
      v-if="behaviorCreateDescription.showPlaceholderAddNewSection"
    >
      <div class="placeholder-add-new-item">
        <v-icon color="primary" size="20">mdi-plus</v-icon>
        <span>Add Section</span>
      </div>
    </div>
    <!-- section-item -->
    <div ref="hurryBoxContainer">
      <div v-if="behaviorCreateDescription.showSectionItem" class="">
        <div
          class="product-section-item"
          v-for="(section, index) in visibleSections"
          :key="section.id"
          :id="section.id"
        >
          <div class="section-item-actions">
            <div class="action-item" @click="handleViewSection(section)">
              <v-icon color="primary" size="19">mdi-expand-all</v-icon>
              <span>Expand</span>
            </div>
            <div class="action-item" @click="handleViewSectionEditor(section)">
              <v-icon color="primary" size="19">mdi-pencil</v-icon>
              <span>Edit</span>
            </div>
            <div class="action-item" @click="handleDeleteSection(section)">
              <v-icon color="error" size="20">mdi-delete</v-icon>
              <span>Delete</span>
            </div>
          </div>
          <div class="move-action">
            <div
              :class="index === 0 ? 'move-action-item-disabled' : 'move-action-item'"
              @click="handleMoveSection(section, 'up')"
            >
              <v-icon color="primary" size="20">mdi-arrow-up</v-icon>
            </div>
            <div
              :class="index === visibleSections.length - 1 ? 'move-action-item-disabled' : 'move-action-item'"
              @click="handleMoveSection(section, 'down')"
            >
              <v-icon color="primary" size="20">mdi-arrow-down</v-icon>
            </div>
          </div>
          <div class="insert-new-section-action">
            <div class="insert-new-section-action-item" @click="handleInsertNewSection(section, 'above')">
              <v-icon color="primary" size="20">mdi-plus</v-icon>
              <span>Add Section Above</span>
            </div>
            <div class="insert-new-section-action-item" @click="handleInsertNewSection(section, 'below')">
              <v-icon color="primary" size="20">mdi-plus</v-icon>
              <span>Add Section Below</span>
            </div>
          </div>
          <div v-html="section.html"></div>
        </div>
      </div>
    </div>

    <!-- Template Modal -->
    <SelectSectionTemplate
      :open="showSectionTemplateModal"
      :hurrybox="true"
      @select="handleSectionTemplateSelect"
      @close="handleCloseSectionTemplateModal"
    />
    <!-- View Section Modal -->
    <v-dialog v-model="viewExpandSection.showViewSection" fullscreen hide-overlay>
      <ViewSectionTemplate
        v-if="viewExpandSection.showViewSection"
        :open="viewExpandSection.showViewSection"
        :hurrybox="true"
        :section="viewExpandSection.section"
        @close="handleCloseViewSection"
      />
    </v-dialog>

    <!-- View Section Editor Modal -->
    <FreestyleSectionEditor
      v-if="
        viewSectionEditor.show &&
          (viewSectionEditor.section.type === sectionType.sectionFreestyleHurryBox ||
            viewSectionEditor.section.type === sectionType.sectionFreestyle)
      "
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CountdownSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCoutdownHurryBox"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SizingChartSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSizingChartHurryBox"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <HarryboxYuriSectionEditor
      v-if="
        viewSectionEditor.show &&
          (viewSectionEditor.section.type === sectionType.sectionHarryboxYuri ||
            viewSectionEditor.section.type === 'section-hurrybox-yuri-section')
      "
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <IconWithTextB1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionIconWithTextB1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SaintbrandFeaturesGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSaintbrandFeaturesGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MadamSizeCalculatorSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMadamSizeCalculator"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <EskiinHurryboxSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionEskiinHurrybox"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
  </div>
</template>
<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { extractDataAttributesFromHTML } from './common/html/extract';
import { cloneDeepObject } from './common/utils';
import { sectionType } from './common/types';
import SelectSectionTemplate from './modal-sections/select-section-template.vue';
import ViewSectionTemplate from './modal-sections/view-section.vue';
import FreestyleSectionEditor from './section-editor/freestyle-hurrybox.vue';
import CountdownSectionEditor from './section-editor/coutdown-hurrybox.vue';
import SizingChartSectionEditor from './section-editor/sizing-chart-hurrybox.vue';
import HarryboxYuriSectionEditor from './section-editor/harrybox-yuri.vue';
import IconWithTextB1SectionEditor from './section-editor/icon-with-text-b1.vue';
import { descriptionjs } from './main';
import {
  deleteSection,
  insertSections,
  loadSectionsFromHtml,
  regenerateSectionIds,
  resolveSectionInsertIndex,
} from './common/insert-section.js';
import SaintbrandFeaturesGridSectionEditor from './section-editor/saintbrand-features-grid.vue';
import MadamSizeCalculatorSectionEditor from './section-editor/madam-size-calculator.vue';
import EskiinHurryboxSectionEditor from './section-editor/eskiin-hurrybox.vue';

export default {
  name: 'HurryBox',
  components: {
    SelectSectionTemplate,
    ViewSectionTemplate,
    FreestyleSectionEditor,
    CountdownSectionEditor,
    SizingChartSectionEditor,
    HarryboxYuriSectionEditor,
    IconWithTextB1SectionEditor,
    SaintbrandFeaturesGridSectionEditor,
    MadamSizeCalculatorSectionEditor,
    EskiinHurryboxSectionEditor,
  },
  props: {
    model: {
      type: String,
      default: 'shortDescription',
    },
    catalog: {
      type: Object,
      required: true,
    },
    catalogCreation: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      createDescriptionBy: 'template',
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      indexInsertNewSection: -1,
      sectionType,
      sections: [],
      showSectionTemplateModal: false,
      viewExpandSection: {
        hurrybox: false,
        showViewSection: false,
        section: {},
      },
      viewSectionEditor: {
        show: false,
        sectionExtract: {},
        section: {},
      },
    };
  },
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const elementPosition = element.offsetTop + 132;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
        element.classList.add('active-section');
        setTimeout(() => {
          element.classList.remove('active-section');
        }, 3000);
      }
    },
    handleViewSection(section) {
      const uniqueId = Math.random()
        .toString(36)
        .slice(2, 8);
      const regex = new RegExp(`prl-[a-z0-9]{6}`, 'g');

      this.viewExpandSection.hurrybox = true;
      this.viewExpandSection.showViewSection = true;
      this.viewExpandSection.section = {
        ...section,
        html: section.html.replace(regex, uniqueId),
      };
    },
    handleCloseViewSection() {
      this.viewExpandSection.hurrybox = false;
      this.viewExpandSection.showViewSection = false;
      this.viewExpandSection.section = {};
    },
    handleViewSectionEditor(section) {
      switch (section.type) {
        case sectionType.sectionFreestyleHurryBox:
        case sectionType.sectionFreestyle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFreestyleHurryBox(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCoutdownHurryBox: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCountdownHurryBox(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSizingChartHurryBox: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSizingChartHurryBox(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionHarryboxYuri: {
          const sectionExtract = extractDataAttributesFromHTML.sectionHarryboxYuri(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionIconWithTextB1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionIconWithTextB1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSaintbrandFeaturesGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSaintbrandFeaturesGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMadamSizeCalculator: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMadamSizeCalculator(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionEskiinHurrybox: {
          const sectionExtract = extractDataAttributesFromHTML.sectionEskiinHurrybox(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        default:
          break;
      }
    },
    handleCloseSectionEditor() {
      this.viewSectionEditor = {
        show: false,
        sectionExtract: {},
        section: {},
      };
    },
    handleUpdateSection(section) {
      this.sections = this.sections.map(item => (item.id === section.id ? section : item));
    },
    handleDeleteSection(section) {
      this.sections = deleteSection(this.sections, section);
    },
    handleInsertAllSections(templates) {
      this.sections = insertSections(this.sections, templates);
      this.showSectionTemplateModal = false;
    },
    handleRemoveAllSections() {
      if (window.confirm('Are you sure to remove all hurry box sections?')) {
        this.sections = [];
      }
    },
    async handleCopySections() {
      const html = (this.sections || []).map(section => section.html).join('');
      if (!html) {
        this.$store.commit('setMessages', { messages: 'No sections to copy', type: 'warning' });
        return;
      }

      try {
        await navigator.clipboard.writeText(html);
        this.$store.commit('setMessages', { messages: 'Sections copied to clipboard', type: 'success' });
      } catch (err) {
        console.error('Failed to copy sections: ', err);
        this.$store.commit('setMessages', { messages: 'Failed to copy sections', type: 'error' });
      }
    },
    async handlePasteSections() {
      let clipboardText = '';
      try {
        clipboardText = await navigator.clipboard.readText();
      } catch (err) {
        console.error('Failed to read clipboard: ', err);
        this.$store.commit('setMessages', {
          messages: 'Unable to read clipboard. Please allow clipboard permission and try again.',
          type: 'error',
        });
        return;
      }

      if (!clipboardText?.trim()) {
        this.$store.commit('setMessages', { messages: 'Clipboard is empty', type: 'warning' });
        return;
      }

      const parsedSections = regenerateSectionIds(loadSectionsFromHtml(clipboardText));
      if (!parsedSections.length) {
        this.$store.commit('setMessages', { messages: 'No valid sections found in clipboard', type: 'warning' });
        return;
      }

      this.sections = insertSections(this.sections, parsedSections);
      this.$store.commit('setMessages', { messages: 'Sections pasted', type: 'success' });
    },
    handleCloseSectionTemplateModal() {
      this.showSectionTemplateModal = false;
      this.indexInsertNewSection = -1;
    },
    handleShowPopupSelectSectionTemplate() {
      this.showSectionTemplateModal = true;
    },
    handleSectionTemplateSelect(template) {
      const atIndex = this.indexInsertNewSection >= 0 ? this.indexInsertNewSection : undefined;
      this.sections = insertSections(this.sections, template, { atIndex });
      this.showSectionTemplateModal = false;
      this.indexInsertNewSection = -1;
      setTimeout(() => {
        this.scrollToSection(template.id);
      }, 100);
    },
    handleMoveSection(section, direction) {
      const index = this.sections.findIndex(item => item.id === section.id);
      if (index === -1) return;
      const newSections = cloneDeepObject(this.sections);
      if (direction === 'up') {
        if (index === 0) return;
        newSections.splice(index, 1);
        newSections.splice(index - 1, 0, section);
      } else if (direction === 'down') {
        if (index === newSections.length - 1) return;
        newSections.splice(index, 1);
        newSections.splice(index + 1, 0, section);
      } else {
        return;
      }
      this.sections = newSections.map((item, index) => ({ ...item, position: index }));
      setTimeout(() => {
        this.scrollToSection(section.id);
      }, 100);
    },
    handleInsertNewSection(section, position) {
      const insertIndex = resolveSectionInsertIndex(this.sections, { section, position });
      if (insertIndex < 0) return;
      this.indexInsertNewSection = insertIndex;
      this.handleShowPopupSelectSectionTemplate();
    },
    handleSwitchCreateDescription() {
      this.createDescriptionBy = this.createDescriptionBy === 'editor' ? 'template' : 'editor';
      this.catalog[this.model] = '';
      this.sections = [];
    },
  },
  computed: {
    behaviorCreateDescription() {
      const objState = {};
      if (this.catalogCreation) {
        objState.nameActionSwitch = this.createDescriptionBy === 'editor' ? 'Use template' : 'Use editor';
        objState.showCkEditor = this.createDescriptionBy === 'editor';
        objState.showSwitchCreateDescription = true;
        objState.showPlaceholderAddNewSection =
          this.visibleSections.length === 0 && this.createDescriptionBy === 'template';
        objState.showSectionItem = this.createDescriptionBy === 'template';
      } else {
        objState.nameActionSwitch = '';
        objState.showCkEditor = false;
        objState.showSwitchCreateDescription = false;
        objState.showPlaceholderAddNewSection = this.visibleSections.length === 0;
        objState.showSectionItem = true;
      }

      return objState;
    },
    visibleSections() {
      return (this.sections || []).filter(s => !s?.hidden);
    },
  },
  mounted() {
    this.sections = loadSectionsFromHtml(this.catalog[this.model]);
    this.$root.$on('insert-all-hurrybox-sections', this.handleInsertAllSections);
    this.$root.$on('remove-all-hurrybox-sections', this.handleRemoveAllSections);
  },
  beforeDestroy() {
    this.$root.$off('insert-all-hurrybox-sections', this.handleInsertAllSections);
    this.$root.$off('remove-all-hurrybox-sections', this.handleRemoveAllSections);
  },
  watch: {
    catalog: {
      handler(newVal) {
        this.sections = loadSectionsFromHtml(newVal[this.model]);
      },
    },
    sections: {
      handler(newVal) {
        this.$emit(
          'update:sectionsPanel',
          (newVal || [])
            .filter(s => !s?.hidden)
            .map(section => ({
              title: section.title,
              id: section.id,
            })),
        );
        this.$emit('update:bodyHtmlHurryBox', newVal.map(section => section.html).join(''));
        this.$nextTick(() => {
          const container = this.$refs.hurryBoxContainer;
          if (!container) return;

          const scriptsSwiper = container.querySelector('script[data-attribute="script-swiper"]');

          if (scriptsSwiper) {
            const newScriptCDN = document.createElement('script');
            newScriptCDN.src = scriptsSwiper.getAttribute('src');
            newScriptCDN.setAttribute('data-ignore', 'true');

            newScriptCDN.onload = () => {
              runOtherScripts();
            };

            scriptsSwiper.parentNode.replaceChild(newScriptCDN, scriptsSwiper);
          } else {
            runOtherScripts();
          }

          function runOtherScripts() {
            const scripts = container.querySelectorAll('script:not([data-executed]):not([data-ignore])');
            scripts.forEach(script => {
              const newScript = document.createElement('script');
              for (const attr of script.attributes) newScript.setAttribute(attr.name, attr.value);
              newScript.text = script.textContent;
              // newScript.setAttribute('type', 'module')
              script.parentNode.replaceChild(newScript, script);
              newScript.setAttribute('data-executed', '1');
            });
          }
          descriptionjs();
        });
      },
    },
  },
};
</script>
